/**
 * 본인인증 테스트 모드 여부
 * 웹은 쿠키로 유지
 */
export const COOKIE_KEY_BYPASS_SELF_AUTH = 'BYPASS_SELF_AUTH';

/**
 * 웹뷰 띄울 때 전달하는 본인인증 테스트 모드 여부
 * value 가 true 일 때만 테스트모드 on
 */
export const HEADER_KEY_BYPASS_SELF_AUTH = 'X-Bypass-Self-Auth';

/**
 * 유저의 언어 설정
 */
export const COOKIE_KEY_LOCALE = 'NEXT_LOCALE';

/**
 * 유저의 디바이스 언어
 */
export const COOKIE_KEY_DEVICE_LANG = 'DEVICE_LANG';

/**
 * 유저의 서비스 언어(컨텐츠 노출 언어)
 */
export const COOKIE_KEY_SERVICE_LANG = 'SERVICE_LANG';

/**
 * 유저가 임의로 설정한 geo_ip
 * appInit에서 현재 IP 기준으로 내려준 실제 geo ip를 덮어씁니다.
 */
export const COOKIE_KEY_MANUAL_GEO_IP = 'MANUAL_GEO_IP';

/**
 * 카카오뱅크 본인인증 강제 설정
 * 개발 환경에서 카카오뱅크 본인인증 사용 가능 상태를 테스트하기 위한 쿠키
 */
export const COOKIE_KEY_FORCE_KAKAOBANK_CERT = 'FORCE_KAKAOBANK_CERT';
